document.addEventListener('turbolinks:load', () => {

  closeDropdown();
  
  const Topmenu_height = 50;
  var dropdown = $(".dropdown");
  var dropdownchild = $(".dropdown_child");
  var dropdownOpen;

  dropdown.on({
    click: function(){
      toggleDropdown();
    }
  }) 

  dropdownchild.on({
    click: function(){
      closeDropdown();
    }
  }) 
  
  $(".dropdown_cover").on({
    click: function(){
      closeDropdown();
    }
  }) 

  function toggleDropdown(){
    if (dropdownOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }

  function openDropdown(){
    var off = $('.dropdown').offset();
    $('.dropdown_menu').offset({ top: off.top+Topmenu_height, left: off.left - 200 + 105 });
    $(".dropdown_menu ul").removeClass("dropdown_menu_hide");
    $(".dropdown_menu li").show();
    $(".dropdown_cover").removeClass("dropdown_menu_hide");
    dropdownOpen = true;
  }
    
  function closeDropdown(){
    $(".dropdown_menu ul").addClass("dropdown_menu_hide");
    $(".dropdown_menu li").hide();
    $(".dropdown_cover").addClass("dropdown_menu_hide");
    dropdownOpen = false;
  }


});